@if (display(); as displayValue) {
  @if (displayValue.isRequired) {
    @if (displayValue.value) {
      @if (showLabel()) {
        <div class="font-bold">{{ label() }}</div>
      }
      <div>{{ displayValue.value }}</div>
    } @else {
      @if (showLabel()) {
        <div class="font-bold text-red-500">{{ label() }}</div>
      }
      <div class="flex items-center text-xs text-red-500">
        <mat-icon class="!h-4 !w-4 !text-xs">error</mat-icon>
        @if (compactWarning()) {
          <span class="text-xs">This field is required</span>
        } @else {
          <div>{{ label() }} is required</div>
        }
      </div>
    }
  } @else {
    @if (showLabel()) {
      <div class="font-bold">{{ label() }}</div>
    }
    <div>{{ displayValue.value || '' }}</div>
  }
}
